import PropTypes from 'prop-types';

export const InfoPageOptions = {
  industries: PropTypes.object.isRequired,
  jobs: PropTypes.arrayOf(PropTypes.string).isRequired,
  skill_levels: PropTypes.arrayOf(PropTypes.string).isRequired,
};
